<script lang="ts">
	import { postStore, setPostTitle } from '$lib/posts';
	import DOMPurify from 'dompurify';
	import * as styles from './styles';

	export let create;

	function toTitleCase(str: string): string {
		return str.replace(
			/\w\S*/g,
			(txt) => txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase()
		);
	}

	const setTitle = () => {
		if ($postStore.title !== undefined) {
			const TITLE_CASED = toTitleCase($postStore.title);
			const CLEAN = DOMPurify.sanitize(TITLE_CASED);
			$postStore.title = CLEAN;

			if (!create && typeof CLEAN === 'string' && typeof $postStore.id === 'string')
				setPostTitle($postStore.id, CLEAN);
		}
	};

	const textFieldTitle =
		'text-xl md:text-2xl lg:text-3xl 3xl:text-4xl font-normal text-gray-200 font-exo-2 ';
</script>

<div class="flex flex-col gap-1">
	<div class={styles.labelText}>title</div>
	<div class="flex text-gray-200">
		<div class={styles.inputDiv}>
			<input
				bind:value={$postStore.title}
				on:change={setTitle}
				class="flex-grow pt-2 pb-2 {styles.placeholderBoxComponent} {textFieldTitle} !font-bold !font-gray-200"
				type="text"
				minlength="4"
				maxlength="100"
				size="50"
				required
			/>
		</div>
	</div>
</div>
